// General
export const DELETE_IMAGES = 'DELETE_IMAGES';
export const CLEAR_SYSTEM_NOTIFICATIONS = 'CLEAR_SYSTEM_NOTIFICATIONS';
export const SET_FEEDBACK = 'SET_FEEDBACK';
export const CLEAR_FEEDBACKS = 'CLEAR_FEEDBACKS';
export const SET_SYSTEM_NOTIFICATIONS = 'SET_SYSTEM_NOTIFICATIONS';
export const SET_SUBMITTING = 'SET_SUBMITTING';
export const ADD_IMAGE = 'ADD_IMAGE';
export const SET_IMAGES = 'SET_IMAGES';
export const ADD_NON_STANDARD_IMAGE = 'ADD_NON_STANDARD_IMAGE';
export const SET_NON_STANDARD_IMAGES = 'SET_NON_STANDARD_IMAGES';
export const SET_ADDITIONAL_IMAGES = 'SET_ADDITIONAL_IMAGES';
export const SET_FILES_TO_UPLOAD = 'SET_FILES_TO_UPLOAD';

// Authentication
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_USER = 'SET_USER';
export const CLEAR_USER = 'CLEAR_USER';

// Jobs
export const MY_JOBS = 'MY_JOBS';
export const OTHER_JOBS = 'OTHER_JOBS';
export const SORT_JOBS = 'SORT_JOBS';
export const FILTERS = 'FILTERS';
export const SET_STC_FILTER = 'SET_STC_FILTER';
export const SET_CC_FILTER = 'SET_CC_FILTER';
export const SET_DISTRIBUTOR_FILTER = 'SET_DISTRIBUTOR_FILTER';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const SET_OFFSET = 'SET_OFFSET';

// Add job
export const ADD_JOB = 'ADD_JOB';

// Single job
export const SET_SINGLE_JOB = 'SET_SINGLE_JOB';
export const SET_MATERIAL_NUMBER_OPTIONS = 'SET_MATERIAL_NUMBER_OPTIONS';
export const SEARCHED_TEAM_MEMBERS = 'SEARCHED_TEAM_MEMBERS';
export const DELETE_SINGLE_JOB = 'DELETE_SINGLE_JOB';
export const CLEAR_JOB = 'CLEAR_JOB';
export const CLEAR_MATERIAL_NUMBER_OPTIONS = 'CLEAR_MATERIAL_NUMBER_OPTIONS';
export const SET_INITIAL_WARRANTY_CODE_OPTIONS = 'SET_INITIAL_WARRANTY_CODE_OPTIONS';

// Forms
export const SET_RECEIVED_PRODUCT = 'SET_RECEIVED_PRODUCT';
export const SET_PRODUCT_EVALUATION = 'SET_PRODUCT_EVALUATION';
export const SET_STRIP_OBSERVATION = 'SET_STRIP_OBSERVATION';
export const SET_TECHNICAL_INVESTIGATION = 'SET_TECHNICAL_INVESTIGATION';
export const SET_CONFORMITY_TEST = 'SET_CONFORMITY_TEST';
export const SET_QUESTION_OPTIONS = 'SET_QUESTION_OPTIONS';
export const SET_CHANGED_OPTIONS = 'SET_CHANGED_OPTIONS';
export const SET_ACTION_MODE = 'SET_ACTION_MODE';

// Logs
export const GET_LOGS = 'GET_LOGS';
export const GET_TOTAL_LOGS = 'GET_TOTAL_LOGS';
export const CLEAR_LOGS = 'CLEAR_LOGS';

// Comments
export const SET_COMMENTS = 'SET_COMMENTS';
export const CLEAR_COMMENTS = 'CLEAR_COMMENTS';
export const SET_TOTAL_COMMENTS = 'SET_TOTAL_COMMENTS';
export const SET_UNREAD_COMMENTS_NUMBER = 'SET_UNREAD_COMMENTS_NUMBER';
export const CLEAR_UNREAD_COMMENTS_NUMBER = 'CLEAR_UNREAD_COMMENTS_NUMBER';
export const SET_FETCHING_COMMENTS = 'SET_FETCHING_COMMENTS';

// Reports
export const GET_REPORT_TEMPLATES = 'GET_REPORT_TEMPLATES';

// Import job
export const GET_SAP_JOBS = 'GET_SAP_JOBS';
export const CLEAR_JOBS = 'CLEAR_JOBS';

// Action mode
export const SET_CURRENT_INDEX = 'SET_CURRENT_INDEX';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js